// Token key in localStorage
const TOKEN_KEY = 'webhook_token'

// Set token with expiration (7 days)
export const setToken = (token) => {
  const expirationDate = new Date()
  expirationDate.setDate(expirationDate.getDate() + 7)
  
  const tokenData = {
    value: token,
    expiry: expirationDate.getTime()
  }
  
  localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenData))
}

// Get token and check expiration
export const getToken = () => {
  const tokenStr = localStorage.getItem(TOKEN_KEY)
  if (!tokenStr) return null
  
  const tokenData = JSON.parse(tokenStr)
  const now = new Date().getTime()
  
  if (now > tokenData.expiry) {
    localStorage.removeItem(TOKEN_KEY)
    return null
  }
  
  return tokenData.value
}

// Remove token
export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY)
}

// Check if user is logged in
export const isLoggedIn = () => {
  return !!getToken()
} 